<template>
    <span class="governance-status-badge" :class="`governance-status-badge--${tone}`">{{ status }}</span>
</template>

<script>
    const TONE_BY_STATUS = {
        CREATED: 'neutral',
        READY: 'neutral',
        BROADCASTING: 'progress',
        WAITING: 'progress',
        EXPANDING: 'progress',
        RESERVED: 'success',
        COMPLETED: 'success',
        STOPPED: 'neutral',
        CANCELLED: 'neutral',
        EXHAUSTED: 'danger',
    }

    export default {
        props: {
            status: { type: String, required: true },
        },

        computed: {
            tone() {
                return TONE_BY_STATUS[this.status] || 'neutral'
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables';

    .governance-status-badge {
        display: inline-block;
        padding: 2px 10px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 600;
        white-space: nowrap;
        letter-spacing: 0.02em;

        &--neutral {
            background: $color--bg-dropdown;
            color: $color--txt-base-2;
        }

        &--progress {
            background: rgba($color--accent-9, 0.12);
            color: $color--accent-15;
        }

        &--success {
            background: rgba($color--accent-10, 0.12);
            color: $color--accent-10;
        }

        &--danger {
            background: rgba($color--accent-8, 0.12);
            color: $color--accent-8;
        }
    }
</style>
